<template>
  <OrganismLogOut/>
</template>

<script>
export default {
  name: 'LogOut',

  components: {
    OrganismLogOut: () => import('@/components/organisms/OrganismLogOut')
  },

  mounted () {
    this.$auth.logout()
  }
}
</script>
